import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { getStudentTests, getStudents } from '../../api';

export default function AdminStudentTests() {
  const { studentId } = useParams();
  const navigate = useNavigate();

  const { data: students = [] } = useQuery({
    queryKey: ['students'], queryFn: () => getStudents().then(r => r.data)
  });
  const student = students.find(s => s.id === studentId);

  const { data: tests = [], isLoading } = useQuery({
    queryKey: ['studentTests', studentId],
    queryFn: () => getStudentTests(studentId).then(r => r.data),
  });

  return (
    <div>
      <div style={{ display: 'flex', alignItems: 'center', gap: 16, marginBottom: 28 }}>
        <button className="btn btn-ghost" onClick={() => navigate('/admin/students')}>Back</button>
        <div>
          <h1 style={{ fontSize: 26 }}>{student?.full_name || 'Student'} — Tests</h1>
          <p style={{ color: 'var(--text-muted)', fontSize: 14 }}>{tests.filter(t => t.status === 'completed').length} completed</p>
        </div>
      </div>

      {isLoading ? <div className="spinner" /> : (
        <div className="card" style={{ padding: 0 }}>
          <table className="table">
            <thead>
              <tr>
                <th>Test</th>
                <th>Date</th>
                <th>Questions</th>
                <th>Attempt %</th>
                <th>Accuracy %</th>
                <th>Score</th>
                <th>Status</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {tests.length === 0 ? (
                <tr><td colSpan={8} style={{ textAlign: 'center', padding: 40, color: 'var(--text-muted)' }}>
                  No tests taken yet.
                </td></tr>
              ) : tests.map(t => (
                <tr key={t.id}>
                  <td style={{ fontWeight: 500 }}>{t.title || 'Untitled'}</td>
                  <td style={{ fontSize: 13, color: 'var(--text-muted)' }}>
                    {new Date(t.started_at).toLocaleDateString('en-IN', { day: '2-digit', month: 'short', year: 'numeric' })}
                  </td>
                  <td>{t.total_questions}</td>
                  <td><span style={{ fontWeight: 600, color: 'var(--primary)' }}>
                    {t.attempt_pct != null ? `${Number(t.attempt_pct).toFixed(1)}%` : '—'}
                  </span></td>
                  <td><span style={{ fontWeight: 600, color: 'var(--success)' }}>
                    {t.accuracy_pct != null ? `${Number(t.accuracy_pct).toFixed(1)}%` : '—'}
                  </span></td>
                  <td><span style={{ fontWeight: 700 }}>
                    {t.score != null ? `${t.score}/${t.max_score}` : '—'}
                  </span></td>
                  <td><span className={`badge ${t.status === 'completed' ? 'badge-green' : 'badge-yellow'}`}>
                    {t.status}
                  </span></td>
                  <td>
                    {t.status === 'completed' && (
                      <button className="btn btn-ghost btn-sm"
                        onClick={() => window.open(`/admin/test-review/${t.id}`, '_blank')}>
                        Review
                      </button>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
